var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              !_vm.printMode
                ? [
                    _c(
                      "div",
                      { staticClass: "table-page-search-wrapper" },
                      [
                        _c(
                          "a-form",
                          {
                            attrs: { layout: "inline" },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.searchQuery.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "a-row",
                              { attrs: { gutter: 24 } },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "门店",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("store-tenant-select", {
                                          attrs: { domain: "sale" },
                                          on: {
                                            change: _vm.handleStoreTenantChange,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "单据日期",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-range-picker", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            format: "YYYY-MM-DD",
                                            placeholder: [
                                              "开始日期",
                                              "结束日期",
                                            ],
                                          },
                                          on: { change: _vm.onDateChange },
                                          model: {
                                            value: _vm.queryParam.dateRange,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "dateRange",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.dateRange",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "类别",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-tree-select", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            dropdownStyle: {
                                              maxHeight: "200px",
                                              overflow: "auto",
                                            },
                                            "allow-clear": "",
                                            treeData: _vm.categoryTree,
                                            placeholder: "请选择类别",
                                          },
                                          model: {
                                            value: _vm.queryParam.categoryId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "categoryId",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.categoryId",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.orgaTree.length
                                  ? _c(
                                      "a-col",
                                      { attrs: { md: 6, sm: 24 } },
                                      [
                                        _c(
                                          "a-form-item",
                                          {
                                            attrs: {
                                              label: "机构",
                                              labelCol: _vm.labelCol,
                                              wrapperCol: _vm.wrapperCol,
                                            },
                                          },
                                          [
                                            _c("a-tree-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                "allow-clear": "",
                                                treeData: _vm.orgaTree,
                                                placeholder: "请选择机构",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryParam.organizationId,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryParam,
                                                    "organizationId",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryParam.organizationId",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c("a-col", { attrs: { md: 6, sm: 24 } }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "table-page-search-submitButtons",
                                    },
                                    [
                                      _c(
                                        "a-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: { click: _vm.searchQuery },
                                        },
                                        [_vm._v("查询")]
                                      ),
                                      _c(
                                        "a-button",
                                        {
                                          staticStyle: { "margin-left": "8px" },
                                          on: { click: _vm.searchReset },
                                        },
                                        [_vm._v("重置")]
                                      ),
                                      _vm.btnEnableList.indexOf("5") > -1
                                        ? _c(
                                            "a-button",
                                            {
                                              staticStyle: {
                                                "margin-left": "8px",
                                              },
                                              attrs: { icon: "printer" },
                                              on: { click: _vm.handlePrint },
                                            },
                                            [_vm._v("打印")]
                                          )
                                        : _vm._e(),
                                      _vm.btnEnableList.indexOf("3") > -1
                                        ? _c(
                                            "a-button",
                                            {
                                              staticStyle: {
                                                "margin-left": "8px",
                                              },
                                              attrs: { icon: "download" },
                                              on: { click: _vm.exportExcel },
                                            },
                                            [_vm._v("导出")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "section",
                      { ref: "print", attrs: { id: "reportPrint" } },
                      [
                        _c("a-table", {
                          ref: "table",
                          attrs: {
                            bordered: "",
                            size: "middle",
                            rowKey: "rowIndex",
                            columns: _vm.columns,
                            dataSource: _vm.dataSource,
                            pagination: false,
                            scroll: _vm.scroll,
                            loading: _vm.loading,
                          },
                          on: { change: _vm.handleTableChange },
                        }),
                        _c(
                          "a-row",
                          {
                            staticStyle: {
                              "margin-top": "8px",
                              "text-align": "right",
                            },
                            attrs: { gutter: 24 },
                          },
                          [
                            _c(
                              "a-col",
                              { attrs: { md: 24, sm: 24 } },
                              [
                                _c("a-pagination", {
                                  attrs: {
                                    size: "small",
                                    "show-size-changer": "",
                                    "show-quick-jumper": "",
                                    current: _vm.ipagination.current,
                                    "page-size": _vm.ipagination.pageSize,
                                    "page-size-options":
                                      _vm.ipagination.pageSizeOptions,
                                    total: _vm.ipagination.total,
                                    "show-total": (total) => `共 ${total} 条`,
                                  },
                                  on: {
                                    change: _vm.paginationChange,
                                    showSizeChange:
                                      _vm.paginationShowSizeChange,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "buildOptionText",
                                        fn: function (props) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(props.value) + "条/页"
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    198454938
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.printMode
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "print-header",
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                          "align-items": "center",
                          padding: "8px 16px",
                          background: "#fff",
                          "border-bottom": "1px solid #e8e8e8",
                          "margin-bottom": "12px",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "16px",
                              "font-weight": "500",
                            },
                          },
                          [_vm._v(_vm._s(_vm.printTitle))]
                        ),
                        _c(
                          "a-button",
                          {
                            attrs: { icon: "close" },
                            on: {
                              click: function ($event) {
                                _vm.printMode = false
                              },
                            },
                          },
                          [_vm._v("关闭")]
                        ),
                      ],
                      1
                    ),
                    _c("ReportPrint", {
                      attrs: {
                        visible: true,
                        tableData: _vm.dataSource,
                        queryParam: _vm.queryParam,
                        billType: "SALE_RATIO",
                        billTypeName: "销售占比",
                        buildData: _vm.buildPrintData,
                        embedded: true,
                      },
                      on: { "designer-change": _vm.onDesignerChange },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }